import { Cloudfront } from "../../redux";

export const getFileUrlFromCloudfront = (cloudfront: Cloudfront) => (filename: string): string => {
    const replacedUrl = filename.replace("fileId=", '')
    return cloudfront.signedFiles.replace('*', encodeURIComponent(replacedUrl))
}